export const getAboutInfoDescriptions = (t) => [
  {
    name: 'Work of Artist',
    value: 'Work of Artist',
    header: t('about_info.work_of_artist.title'),
    description: t('about_info.work_of_artist.description'),
  },
  {
    name: 'Gallery Owned',
    value: 'Gallery owned',
    header: t('about_info.gallery_owned.title'),
    description: t('about_info.gallery_owned.description'),
  },
  {
    name: 'Artist',
    header: t('about_info.artist.title'),
    description: t('about_info.artist.description'),
  },
  {
    name: 'Title',
    header: t('about_info.title.title'),
    description: t('about_info.title.description'),
  },
  {
    name: 'Description',
    header: t('about_info.description.title'),
    description: t('about_info.description.description'),
  }, 
  {
    name: 'Medium',
    header: t('about_info.medium.title'),
    description: t('about_info.medium.description'),
  },
  {
    name: 'Theme',
    header: t('about_info.theme.title'),
    description: t('about_info.theme.description'),
  },
  {
    name: 'Color',
    header: t('about_info.color.title'),
    description: t('about_info.color.description'),
  },
  {
    name: 'Emotion',
    header: t('about_info.emotion.title'),
    description: t('about_info.emotion.description'),
  },
  {
    name: 'Year of Creation',
    header: t('about_info.year_of_creation.title'),
    description: t('about_info.year_of_creation.description'),
  },
  {
    name: 'Dimensions',
    header: t('about_info.dimensions.title'),
    description: t('about_info.dimensions.description'),
  },
  {
    name: 'Price',
    header: t('about_info.price.title'),
    description: t('about_info.price.description'),
  },
  {
    name: 'Limited Editions',
    header: t('about_info.limited_editions.title'),
    description: t('about_info.limited_editions.description'),
  },
];
